'use client';

import { Button } from '@/components/ui/button';
import { IconCheck, IconCopy } from './icons';
import { useCopyToClipboard } from './hooks/use-copy-to-clipboard';
import cn from 'mxcn';
import { Message } from '@baseai/core';

interface ChatMessageActionsProps extends React.ComponentProps<'div'> {
	message: Message;
	isLoading: boolean;
}

export function ChatMessageActions({
	message,
	isLoading,
	className,
	...props
}: ChatMessageActionsProps) {
	const { isCopied, copyToClipboard } = useCopyToClipboard({ timeout: 2000 });

	const onCopy = () => {
		if (isCopied) return;
		copyToClipboard(message.content ?? '');
	};

	return (
		<div
			className={cn(
				'lb-absolute lb-bottom-0 lb-right-0 lb-flex lb-items-center lb-justify-end lb-opacity-0 lb-transition-opacity group-hover:lb-opacity-70',
				className
			)}
			{...props}
		>
			{isLoading && (
				<Button variant="ghost" size="icon" onClick={onCopy}>
					{isCopied ? <IconCheck /> : <IconCopy />}
					<span className="lb-sr-only">Copy message</span>
				</Button>
			)}
		</div>
	);
}
